import React from 'react';
import { Outlet } from 'react-router';
import { KeycloakRoute } from '@europrocurement/l2d-keycloak';
import { CenterCircularProgress } from '@europrocurement/flexy-components';
import { TypeDocumentsProvider, useLoadStore } from '@europrocurement/l2d-modules';

const FormaliteRoot = function () {
    const { getLoadingStatus } = useLoadStore([
        'formalityCategories',
        'legalStatuses',
        'formulairesFormalites',
        'dossierValidators',
    ]);

    if (getLoadingStatus() !== 'succeeded') {
        return <CenterCircularProgress />;
    }

    return (
        <KeycloakRoute roles="realm:interne">
            <TypeDocumentsProvider autoload>
                <Outlet />
            </TypeDocumentsProvider>
        </KeycloakRoute>
    );
};

export default FormaliteRoot;
